<div class="price-container">
  <span class="price">
      <ui-product-prices-formatter
        [price]="price()"
        [showThousandthsPlace]="showThousandthsPlace()"
      ></ui-product-prices-formatter>
  </span>
</div>
